import { useMutation } from 'react-query';
import { useDataProvider } from 'react-admin';
/**
 * Publish a message to a topic
 *
 * @example
 * const [publish, { isLoading }] = usePublish();
 *
 * const handleClick = () => {
 *    publish('resource/posts', {
 *      type: 'created',
 *      payload: { ids: [1] },
 *      date: new Date(),
 *    });
 * }
 */
export var usePublish = function () {
    var dataProvider = useDataProvider();
    var mutation = useMutation(function (params) {
        return dataProvider.publish(params.topic, params.event);
    });
    var publish = function (topic, event, options) {
        mutation.mutate({ topic: topic, event: event }, options);
    };
    return [publish, mutation];
};
